"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = `
albatross
alpacka
anaconda
ape
armadillo
baboon
badger
bat
bear
beaver
bedbug
bird
blobfish
blowfish
bobcat
buffalo
bulldog
bullfrog
bumblebee
camel
cat
catfish
cheetah
chicken
chipmunk
cobra
cougar
cow
crab
crocodile
deer
dingo
dinosaur
dodo
dog
dolphin
donkey
dragon
dragonfly
duck
dugong
eagle
eel
elephant
elk
emu
falcon
ferret
fireant
fish
flamingo
fly
fox
frog
gecko
giraffe
goat
goose
gopher
gorilla
hamster
hedgehog
hippo
horse
hound
husky
hyena
impala
insect
jaguar
jellyfish
kangaroo
kiwi
koala
kolibri
ladybug
lamprey
leopard
liger
lion
lionfish
lizard
llama
lynx
manatee
mantis
mayfly
meerkat
mole
monkey
moose
moth
mouse
mule
narwhal
newt
octopus
ostrich
otter
owl
panda
panther
parrot
peacock
pelican
penguin
pig
piranha
platypus
pony
porcupine
pug
puma
quail
rabbit
racoon
rat
rhino
robin
scorpion
seahorse
seal
shark
sheep
shrimp
skunk
sloth
snail
snake
spider
squid
squirrel
starfish
stingray
swan
termite
tiger
toad
turkey
turtle
unicorn
vampirebat
vulture
walrus
warthog
wasp
whale
wolf
wolverine
wombat
yak
zebra
`
    .trim()
    .split(/\s+/);
//# sourceMappingURL=noun.js.map